import { HTTP } from '@/services/axios';

export async function createLog({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/AuditLog/controlAuditLogSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getAuditLogs({filterText,orderCol,orderSort,page,records,docId,typeId}){
    let result = {};
    await HTTP.get('/app/core/AuditLog/getAuditLogList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records,
            docId,
            typeId
        }
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getAuditLogsByDoc({date,docId}){
    let result = {};
    
    await HTTP.get('/app/core/AuditLog/getAuditLog.php',{
        params:{
            date,
            docId
        }
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}